import { render, staticRenderFns } from "./InvoiceItemsSection.vue?vue&type=template&id=889c2836&"
import script from "./InvoiceItemsSection.vue?vue&type=script&lang=js&"
export * from "./InvoiceItemsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports